

import HelloWorld from './components/HelloWorld.vue'
import io from 'socket.io-client'

export default {
  name: 'LayoutDefault',

  components: {
    HelloWorld
  },

  data() {
    return {
      leftDrawerOpen: false,
      text: '',
      dense: true,

      notifUnread: 0,
      isMuted: false,
      socket: null,
      audioUnlocked: false // ⬅️ WAJIB
    }
  },
  methods: {
    unlockAudio() {
      if (this.audioUnlocked) return

      const audio = this.$refs.notifSound
      if (!audio) return

      audio.volume = 0
      audio.play().then(() => {
        audio.pause()
        audio.currentTime = 0
        audio.volume = 1

        this.audioUnlocked = true
        localStorage.setItem('audioUnlocked', '1')

        this.$q.notify({
          type: 'positive',
          message: 'Notifikasi suara aktif'
        })
      }).catch(() => { })
    },

    playNotifSound() {
      if (!this.audioUnlocked) return

      const audio = this.$refs.notifSound
      if (!audio) return

      audio.currentTime = 0
      audio.play().catch(() => {
        // ❗ browser blokir = NORMAL
        // ❗ jangan dimatikan manual
      })
    },

  },

  computed: {
    checkLogin() {
      if (this.$route.name === 'login') {
        return true;
      } else {
        return false;
      }
    }
  },

  mounted() {

    var get_profile = JSON.parse(localStorage.profile);
    this.$store.state.unit_kerja = get_profile.profile.unit_kerja
    this.$store.state.unit_kerja_nama = get_profile.profile.unit_kerja_nama
    // ================= ROLE =================
    const tipe = Number(get_profile?.profile?.stokdarah_konut)

    const role =
      tipe === 1 || tipe === 2 ? 'admin_upd' :
        tipe === 3 ? 'admin_ruangan' :
          null

    if (!role) return
    // ================= SOCKET =================
    this.socket = io('https://server-pindara.bludrs-konut.id/', {
      transports: ['websocket', 'polling'],
      query: {
        token: localStorage.token
      }
    })

    this.socket.on('connect', () => {
      console.log('✅ SOCKET CONNECTED:', this.socket.id)

      // ===== JOIN ROOM SOCKET =====
      // if (tipe === 1 || tipe === 2) {
      //   this.socket.emit('join_room', 'upd')
      //   console.log('🔔 JOIN ROOM: upd')
      // }

      if (tipe === 3 && get_profile.profile.ruangan_id) {
        this.socket.emit(
          'join_room',
          `ruangan:${get_profile.profile.ruangan_id}`
        )
        console.log(
          '🔔 JOIN ROOM: ruangan:',
          get_profile.profile.ruangan_id
        )
      }
    })



    this.socket.on('permintaan_status_update', (payload) => {
      console.log('🔔 NOTIF DITERIMA:', payload)

      this.notifUnread++

      if (this.audioUnlocked) {
        this.playNotifSound()
      } else {
        this.$q.notify({
          type: 'warning',
          message: 'Klik ikon lonceng untuk mengaktifkan suara notifikasi',
          position: 'top-right',
          timeout: 3000
        })
      }

      // 🔄 BERITAHU HALAMAN AKTIF
  this.$root.$emit('permintaan-updated', payload)

      // Notif visual SELALU tampil
      this.$q.notify({
        type: 'info',
        message: payload.pesan,
        position: 'top-right',
        timeout: 2500
      })
    })

    this.audioUnlocked = false
    localStorage.removeItem('audioUnlocked')


    console.log('TOKEN FRONTEND:', localStorage.getItem('token'))



  },
}
